import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Locale } from 'contexts/locale'
import { ConsumptionProvider } from 'contexts/consumption'
import { MDXProvider } from '@mdx-js/react'
import Methodik from 'text/de/methodology.md'
import AllContent from 'text/de/content.mdx'
import styles from './styles.module.scss'

const ARTICLE_ID = '17000710'

const methodologyStyles = {
  h1: props => <h3 className='ui infographic small header' {...props} />
}

const contentStyles = {
  h3: props => <h3 className='ui infographic small header' {...props} />,
  h4: props => <h4 className='ui infographic tiny header' {...props} />,
  h5: props => <h5 className={styles.smallTitle} {...props} />
}

function AppComponent() {
  return (
    <div className='index'>
      <Locale.Provider value='de'>
        <ConsumptionProvider>
          <Masthead articleId={ARTICLE_ID} />
          <ThemeSwitch />

          <header
            className={`ui vertical very relaxed segment ${styles.cover}`}
          >
            <div className='ui container'>
              <h1 className='ui header'>
                Der Alkohol-Check: Ihr Konsum im Vergleich
                <div className='sub header'>
                  Wie viel Bier, Wein und Schnaps trinken Sie pro Woche? Und wie
                  reiht sich Ihr Konsum im internationalen Vergleich ein? Unser
                  Alkoholrechner weiss es.
                </div>
              </h1>
              <div className='ta author'>
                Kaspar Manz, Marc Brupbacher und Dinja Plattner
              </div>
            </div>
          </header>

          <div className={`ui vertical relaxed segment`}>
            <div className='ui text container'>
              <MDXProvider components={contentStyles}>
                <AllContent />
              </MDXProvider>
            </div>
          </div>

          <Footer
            articleId={ARTICLE_ID}
            questions={[
              'Wie nützlich ist der Alkoholrechner?',
              'Funktionierte die technische Umsetzung?',
              'Wie gefällt Ihnen die Gestaltung?'
            ]}
            credits={[
              ['Text', 'Marc Brupbacher und Dinja Plattner'],
              [
                'Programmierung',
                'Kaspar Manz und Thierry Seiler, Interaktiv-Team'
              ],
              [
                'Quellen',
                'Bundesamt für Gesundheit BAG, World Health Organisation WHO'
              ]
            ]}
          >
            <div className='ui blue vertical segment' id='methodology'>
              <div className='ui text container'>
                <MDXProvider components={methodologyStyles}>
                  <Methodik />
                </MDXProvider>
              </div>
            </div>
          </Footer>
        </ConsumptionProvider>
      </Locale.Provider>
    </div>
  )
}

export default hot(AppComponent)
